module.exports = __webpack_public_path__ + "static/media/project5.f73acec6.jpg";